import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { PropTypes } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ShelfActions from '../actions/ShelfActions';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import OnShelfButton from '@bibliocommons/shared-on-shelf-button';
import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';
import AddToShelfComboButton from '../components/shared/AddToShelfComboButton';
import { getShelvesForCurrentUser, getShelfTransactions } from '../selectors/ShelfSelector';
import { SHELF_NAMES } from '../constants/ShelfConstants';

export class AddToShelfButtonContainer extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleShelfAdd', 'handleClickOnMyShelf');
  }

  static trackShelfAdd(shelf) {
    BCGoogleAnalyticsUtils.event({
      eventCategory: 'NERF Search',
      eventAction: `Add To ${shelf || SHELF_NAMES.FOR_LATER} Shelf`
    });
  }

  handleShelfAdd(newShelf) {
    AddToShelfButtonContainer.trackShelfAdd(newShelf);
    this.props.shelfActions.addToShelf(this.props.metadataId, newShelf);
  }

  handleClickOnMyShelf() {
    const { metadataId, workflowId } = this.props;
    const shelf = this.props.currentShelfItem.get('shelf');
    this.props.shelfActions.showPostAddToShelfView(metadataId, shelf, workflowId || metadataId);
  }

  render() {
    const { currentShelfItem, isAdding, bibBrief, disabled } = this.props;
    if (!currentShelfItem) {
      return (
        <AddToShelfComboButton
          primaryShelfAction={this.props.primaryShelfAction}
          disabled={disabled}
          isLoading={isAdding}
          bibBrief={bibBrief}
          handleClick={this.handleShelfAdd} />
      );
    }
    return (
      <div>
        <OnShelfButton
          disabled={disabled}
          shelfItem={currentShelfItem}
          bibBrief={bibBrief}
          handleClick={this.handleClickOnMyShelf} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { metadataId } = ownProps;
  const currentShelfItem = getShelvesForCurrentUser(state).get(metadataId);
  const isAdding = getShelfTransactions(state).getIn([metadataId, 'isAdding']);
  const bibBrief = state.getIn(['entities', 'bibs', metadataId, 'briefInfo']);
  return { currentShelfItem, isAdding, bibBrief };
};

const mapDispatchToProps = dispatch => ({
  shelfActions: bindActionCreators(ShelfActions, dispatch)
});

AddToShelfButtonContainer.propTypes = {
  currentShelfItem: ImmutablePropTypes.map,
  metadataId: PropTypes.string.isRequired,
  workflowId: PropTypes.string,
  isAdding: PropTypes.bool,
  disabled: PropTypes.bool,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  primaryShelfAction: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AddToShelfButtonContainer));



// WEBPACK FOOTER //
// ./app/containers/AddToShelfButtonContainer.jsx